const KNOWN_FEATURE_LICENSES = [
    "FEATURE_AI_AGENT",
    "FEATURE_MCP",
    "FEATURE_WORKFLOW_BDE",
    "FEATURE_WORKFLOW_BMDE",
    "FEATURE_WORKFLOW_LUN",
    "FEATURE_WORKFLOW_BMP",
] as const;

export type FeatureLicense = (typeof KNOWN_FEATURE_LICENSES)[number];

const KNOWN_FEATURE_LICENSES_SET: ReadonlySet<string> = new Set<FeatureLicense>(KNOWN_FEATURE_LICENSES);

export function isKnownFeatureLicense(featureLicense: string): featureLicense is FeatureLicense {
    return KNOWN_FEATURE_LICENSES_SET.has(featureLicense);
}
